import React from "react";
import type { IconType } from "react-icons";
import { FiCheck, FiGift, FiShield, FiZap } from "react-icons/fi";

const features: { title: string; icon: IconType; points: string[] }[] = [
  {
    title: "Instant Rewards",
    icon: FiGift,
    points: [
      "Gift cards delivered immediately after survey completion",
      "$5-$25 value depending on survey length",
      "Multiple retailer options",
    ],
  },
  {
    title: "Quick & Easy",
    icon: FiZap,
    points: ["Most surveys under 10 minutes", "Mobile-optimized experience", "No complex registration process"],
  },
  {
    title: "Privacy Protected",
    icon: FiShield,
    points: ["AI-powered data validation", "Enterprise-grade security", "Complete anonymity guaranteed"],
  },
];

export const Features = () => {
  return (
    <section id="feature" className="py-16 scroll-mt-24 bg-canvas sm:py-24">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <p className="zs-eyebrow">Features</p>
          <h2 className="mt-1 text-3xl font-bold tracking-tight font-display text-ink sm:text-4xl">
            Why people love us
          </h2>
          <p className="mt-4 text-base leading-relaxed sm:text-lg text-ink-2">
            Quick surveys. Instant rewards. A community that values your time.
          </p>
        </div>

        <div className="grid gap-5 mt-12 sm:mt-16 md:grid-cols-3 lg:gap-6">
          {features.map(({ title, icon: Icon, points }) => (
            <article key={title} className="flex flex-col p-6 zs-card zs-card-interactive sm:p-8">
              <span className="flex items-center justify-center w-12 h-12 text-xl border rounded-lg bg-primary-soft text-primary-text border-primary/15">
                <Icon aria-hidden="true" />
              </span>
              <h3 className="mt-6 text-lg font-semibold font-display text-ink">{title}</h3>
              <ul className="pt-5 mt-5 space-y-3 border-t border-line">
                {points.map((point) => (
                  <li key={point} className="flex items-start gap-3 text-sm leading-relaxed text-ink-2">
                    <span className="flex items-center justify-center w-5 h-5 mt-px rounded-full shrink-0 bg-success-soft text-success">
                      <FiCheck aria-hidden="true" className="w-3 h-3" />
                    </span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
